export const ROLES = {
    super_admin : {
        role : 's', 
        role_display : "Super Admin"
    },
    distributor : {
        role : 'd',
        role_display: 'Distributor'
    },
    customer : {
        role : 'c',
        role_display: 'Customer'
    }
  };


export const getRoleDisplay = (role) => {
    const roleEntry = Object.values(ROLES).find(r => r.role === role);
    return roleEntry?.role_display || role;
};